import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import style from "@/page-components/taggings/tagging.module.css";
import crossIcon from "@/assets/img/closecross.svg";
import styles from "@/page-components/cost-explorer/components/edit-widget/edit-widget.module.css";
import { Offcanvas } from "react-bootstrap";

import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search-without-apply";
import Joi from "joi";
import { joiResolver } from "@hookform/resolvers/joi";
import ToastComponent from "@/page-components/budgets/components/toast";
import { TaggingContext } from "../tagging-context-file";
import { useGetTags } from "@/services/taggings/get-tags.repo";
import { useCreateTagging } from "@/services/taggings/create-virtual-tags.repo";

const CreateVirtualTagModal = ({
  service,
  deleteLoading,
  deleteSuccess,
  deleteError,
  deleteData,
}) => {
  const {
    register,
    handleSubmit,
    getValues,
    control,
    watch,
    setValue,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(CreateVirtualTagSchema),
  });

  const context = useContext(TaggingContext);
  const EditData = context?.Editdata;

  const [toast, setToast] = useState(false);
  const [message, setMessage] = useState();

  const query = useMemo(
    () => ({
      service: service,
    }),
    [service]
  );

  const { data: tagscheckdata } = useGetTags(query);

  const queryType = useMemo(() => (EditData ? "edit" : "create"), [EditData]);
  let {
    mutate: Id,
    data,
    reset: createReset,
    isError,
    error: createError,
    isSuccess: successMessage,
    isPending,
  } = useCreateTagging(queryType);
  const HandleRest = () => {
    reset({
      name: "",
      description: "",
    });
    context?.setSelectTagKeys([]);
  };
  const HandleClose = () => {
    context?.setIsLayoverOpen(false);
    context?.setEditdata();
    HandleRest();
  };

  useEffect(() => {
    HandleRest();
  }, [context?.Editdata]);

  useEffect(() => {
    if (successMessage) {
      HandleClose();
      setMessage({
        message: data?.message,
        type: "success",
      });
      setToast(true);
      context?.refetchTable();
    }
  }, [successMessage]);
  
  useEffect(() => {
    if (deleteSuccess) {
      HandleClose();
      context?.setConfirmationmodal(false);
      setMessage({
        message: deleteData?.message,
        type: "success",
      });
      setToast(true);
      context?.refetchTable();
    }
  }, [deleteSuccess]);

  useEffect(() => {
    if (createError) {
      // HandleClose();
      setMessage({
        message: createError.message,
        type: "Anomaly",
      });
      setToast(true);
    }
  }, [createError]);

  useEffect(() => {
    if (deleteError) {
      HandleClose();
      context?.setConfirmationmodal(false);
      setMessage({
        message: deleteError.message,
        type: "Anomaly",
      });
      setToast(true);
    }
  }, [deleteError]);

  const onSubmit = (formData) => {
    const transformedData = {
      name: formData.name,
      description: formData.description,
      tagKeys: (formData.tagKeys || context?.selectTagKeys || []).map(
        (tag) => tag.name
      ),
      ...(EditData?.tagId && { tagId: EditData.tagId }),
    };

    Id({
      body: transformedData,
      service: service,
    });
  };

  useEffect(() => {
    if (EditData) {
      setValue("name", EditData?.name);
      setValue("description", EditData?.description);

      const tagKeys =
        EditData?.tagKeys?.map((tag) => ({
          id: tag,
          name: tag,
        })) || [];

      setValue("tagKeys", tagKeys);
      context?.setSelectTagKeys?.(tagKeys);
      clearErrors("tagKeys");
    }
  }, [EditData, setValue]);

  const handleSelect = (selectedList) => {
    context?.setSelectTagKeys(selectedList);
  };

  const handleRemove = (selectedList) => {
    handleSelect(selectedList);
  };

  const handleRemoveOne = (itemToRemove) => {
    const updatedList = context?.selectTagKeys?.filter(
      (item) => item.id !== itemToRemove.id
    );
    context?.setSelectTagKeys(updatedList);
  };

  const renderSelectedValues = (selectedValues = [], handleRemoveOne) => {
    return (
      <div className={style.tag_container}>
        {selectedValues.map((item, index) => (
          <div className={style.tag_selected}>
            <span key={index} className={style.tag_pill}>
              {item.name}
            </span>
            <span
              className={style.remove_icon}
              onClick={() => handleRemoveOne(item)}
            >
              &times;
            </span>
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    register("tagKeys", { required: true });
    setValue("tagKeys", context?.selectTagKeys || []);
  }, [register, context?.selectTagKeys]);

  return (
    <>
      {toast && (
        <ToastComponent
          message={message}
          toast={toast}
          setToast={setToast}
          timeout={5000}
        />
      )}

      <Offcanvas
        placement="end"
        show={context?.isLayoverOpen}
        onHide={() => {
          HandleClose();
        }}
        style={{
          width: "40%",
        }}
      >
        <Offcanvas.Header className={style.offcanvas_header}>
          <span className={style.Heading_Cross}>
            {EditData ? "Edit" : "Create"} a Virtual Tag
          </span>
          <img
            src={crossIcon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={() => {
              HandleClose();
            }}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          className={styles.modal_body}
          style={{ padding: "16px 0px 0px" }}
        >
          <div
            style={{ height: "100%", width: "100%" }}
            className={style.Offcanvas_div}
          >
            <form
              onSubmit={handleSubmit(onSubmit)}
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div style={{ padding: "0px 24px 0px 24px" }}>
                <div className={style.form_group}>
                  <label className={style.label}>Virtual Tag Name</label>
                  <input
                    defaultValue={EditData?.name}
                    className={style.input}
                    {...register("name", { required: true })}
                    placeholder="Add Virtual Tag Name"
                  />
                  <div style={{ height: "10px", display: "flex" }}>
                    {errors.name && (
                      <span className="budgetsError">
                        {errors.name.message}
                      </span>
                    )}
                  </div>
                </div>
                <div className={style.tagged_box}>
                  <div
                    className={styles.show_data}
                    style={{ cursor: "pointer", width: "100%" }}
                  >
                    <label className={style.label}>Tag Key</label>
                    <div>
                      <FilterSearch
                        multiselect={true}
                        // options={(tagscheckdata || []).map((e) => {
                        //   return {
                        //     id: e.id,
                        //     name: e.name,
                        //   };
                        // })}
                        options={
                          Array.isArray(tagscheckdata)
                            ? tagscheckdata.map((e) => ({
                                id: e.id,
                                name: e.name,
                              }))
                            : []
                        }
                        selectedValues={context?.selectTagKeys || []}
                        onSelect={(list) => {
                          handleRemove(list);
                          setValue("tagKeys", list);
                          clearErrors("tagKeys");
                        }}
                        onRemove={(list) => {
                          handleRemove(list);
                          setValue("tagKeys", list);
                          clearErrors("tagKeys");
                        }}
                        displayValue="name"
                        placeholder="--Select--"
                        toggle={
                          <>
                            <FilterSearchToggle placeholder="Select Tag Key" />
                          </>
                        }
                      />
                    </div>
                    <div style={{ height: "10px", display: "flex" }}>
                      {errors.tagKeys && (
                        <span className="budgetsError">
                          {errors.tagKeys.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <span style={{ paddingBottom: "12px" }}>
                    {" "}
                    {renderSelectedValues(
                      context?.selectTagKeys,
                      handleRemoveOne
                    )}
                  </span>
                </div>

                <div className={style.form_group}>
                  <label className={style.label}>Description</label>
                  <input
                    defaultValue={EditData?.name}
                    className={style.input}
                    {...register("description", { required: false })}
                    placeholder="Add Description"
                  />
                  <div style={{ height: "10px", display: "flex" }}>
                    {errors.description && (
                      <span className="budgetsError">
                        {errors.description.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="button_box"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "16px 24px 12px 24px",
                }}
              >
                {EditData && (
                  <div>
                    <button
                      type="button"
                      style={{ cursor: "pointer" }}
                      className={style.deleted_button}
                      onClick={() => {
                        context?.setConfirmationmodal(true);
                        context?.setDeleteData(EditData?.tagId);
                      }}
                    >
                      {deleteLoading ? "Deleting..." : "Delete"}
                    </button>
                  </div>
                )}
                <div
                  className="cancel_create_button"
                  style={{ justifyContent: "end", width: "100%" }}
                >
                  <button
                    type="button"
                    style={{ cursor: "pointer" }}
                    className="cancel_button"
                    onClick={() => {
                      HandleClose();
                    }}
                  >
                    Cancel
                  </button>
                  {EditData && (
                    <button type="submit" className="create_button">
                      {isPending ? "Updating..." : "Edit"}
                    </button>
                  )}
                  {!EditData && (
                    <button type="submit" className="create_button">
                      {isPending ? "Creating..." : "Create"}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default CreateVirtualTagModal;

export const CreateVirtualTagSchema = Joi.object({
  name: Joi.string().required().messages({
    "string.empty": "Name is required",
    "any.required": "Name is required",
  }),
  description: Joi.string().required().messages({
    "string.empty": "Description is required",
    "any.required": "Description is required",
  }),
  tagKeys: Joi.array()
    .items(
      Joi.object({
        id: Joi.any().required(),
        name: Joi.string().required(),
      })
    )
    .min(1)
    .required()
    .messages({
      "array.min": "Tag Key is required",
      "any.required": "Tag Keys are required",
    }),
});
